// CRM Group related endpoints
export const CRMGroupEndpoints = (builder) => ({

  getCRMGroups: builder.query({
    query: (args = {}) => {
      const { pageNumber = 1, pageSize = 10, searchTerm, searchValue } = args;
      const params = { pageNumber, pageSize };
      if (searchTerm !== null && searchTerm !== undefined) params.searchTerm = searchTerm;
      if (searchValue !== null && searchValue !== undefined) params.searchValue = searchValue;
      return { url: '/common/crmgroup-list', method: 'GET', params };
    },
    providesTags: ['CRMGroup'],
  }),

  getCRMGroupById: builder.query({
    query: (id) => ({ url: `/common/get-CRMGroupById/${id}`, method: 'GET' }),
    providesTags: (result, error, id) => [{ type: 'CRMGroup', id }],
  }),

  saveCRMGroup: builder.mutation({
    query: (data) => ({ url: '/common/save-crmgroup', method: 'POST', body: data }),
    invalidatesTags: ['CRMGroup'],
  }),

  updateCRMGroup: builder.mutation({
    query: ({ data }) => ({ url: `/common/save-crmgroup`, method: 'POST', body: data }),
    invalidatesTags: (result, error, { id }) => [{ type: 'CRMGroup', id }, 'CRMGroup'],
  }),

  deleteCRMGroup: builder.mutation({
    query: (id) => ({ url: `/common/delete-crmgroup/${id}`, method: 'DELETE' }),
    invalidatesTags: ['CRMGroup'],
  }),

  bulkDeleteCRMGroup: builder.mutation({
    query: (body) => ({ url: '/common/bulk-delete-crmgroup', method: 'DELETE', body }),
  }),

});
